import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CoachChatManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/coach-chat")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CoachChatManagement />
    </RouteGuard>
  ),
});
